var didScroll = false;

$(window).scroll(function() {
    didScroll = true;
});

setInterval(function() {
  var $productgrid = $('#productgrid');
  var $sidebar = $('#sticker');
  var gridHeight = $productgrid.outerHeight(true);
  var gridTop = $productgrid.position().top;
  var sidebarHeight = $sidebar.outerHeight(true);
  

  
  if ( didScroll ) {
    didScroll = false;
    var scroll = $(window).scrollTop();
    var pos = gridHeight - sidebarHeight - 100;
    var posPlus = gridHeight - sidebarHeight - gridTop;
    if (scroll > pos) {
      $("#sticker").css({
        position: 'absolute',
        top: posPlus
      });
    } else {
      $("#sticker").css({
        position: 'fixed',
        top: 'auto'
      });
    }
  }
}, 5);




$(document).ready( function() {
  
  var $firstP = $('#minimized--description > p').first();
//   console.log("P is: ", $firstP)
//   var position = firstP.position();
  var pBottom = $firstP.position().top + $firstP.outerHeight(true);
  
  var $productgrid = $('#productgrid');
  var gridTop = $productgrid.position().top;
  console.log('First P Positiong Bottom: ', pBottom);
  var isMinimized = true;
  $(".minimized--description").css('height', pBottom + 'px');
//   var height = pBottom + 90;
  $(".read-more-button").click(function(){
    
    if(isMinimized) {
      $(".minimized--description").css('height', 'auto');
      $(".read-more-button").html('Read less');

    }else{
//       $("html, body").animate({ scrollTop: 0 }, "fast");
      $(".minimized--description").css('height', pBottom + 'px');
      $(".read-more-button").html('Read more');
            $("#sticker").css({
        position: 'absolute',
        top: gridTop
      });
     
    }
    isMinimized = !isMinimized
  }); 
 });